import React from 'react';

import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';

export const Drag = ({
    id,
    index,
    isDragDisabled = false,
    dragHandlerWrapperClasses = '',
    dragHandlerColor = '',
    dragHandlerClasses = '',
    dragContainerClasses = '',
    style = {},
    wrapperId,
    ...props
}) => {
    return (
        <Draggable draggableId={id} index={index} isDragDisabled={isDragDisabled}>
            {(provided, snapshot) => {
                return (
                    <div id={wrapperId} ref={provided.innerRef} {...provided.draggableProps} style={{ ...provided.draggableProps.style, ...style }} {...props}>
                        <div className={`tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-x-4 tw-w-full ${dragContainerClasses}`}>
                            <div {...provided.dragHandleProps} className={dragHandlerWrapperClasses}>
                                <i
                                    className={classNames('tw-pl-2', 'fas', 'fa-grip-vertical', dragHandlerClasses, {
                                        'tw-text-red-500': dragHandlerColor == 'red',
                                        'tw-text-amber-500': dragHandlerColor == 'amber',
                                        'tw-text-green-500': dragHandlerColor == 'green',
                                        'tw-text-blue-500': dragHandlerColor == 'blue',
                                        'text-light-grey': dragHandlerColor == '' || dragHandlerColor == undefined,
                                    })}
                                />
                            </div>
                            <div className="tw-flex tw-flex-col tw-w-full">{props.children}</div>
                        </div>
                    </div>
                );
            }}
        </Draggable>
    );
};
